import { z } from 'zod';

export const TargetSchema = z.enum(['master', 'drive_board', 'pi', 'cloud']);

export const CapabilitiesSchema = z.object({
  firebase_sync: z.boolean(),
  fleet_view: z.boolean(),
  remote_discovery: z.boolean(),
});

export const InfoSchema = z.object({
  version: z.string(),
  target: TargetSchema,
  capabilities: CapabilitiesSchema,
});

export type ParsedInfo = z.infer<typeof InfoSchema>;
